import { render, staticRenderFns } from "./EnterArticleInformation.vue?vue&type=template&id=aef31246"
import script from "./EnterArticleInformation.vue?vue&type=script&lang=js"
export * from "./EnterArticleInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports